import { render, staticRenderFns } from "./invitation-newuser-bak.vue?vue&type=template&id=6452c87a&scoped=true&"
import script from "./invitation-newuser-bak.vue?vue&type=script&lang=js&"
export * from "./invitation-newuser-bak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6452c87a",
  null
  
)

export default component.exports